import { useEffect, useState } from 'react';
import {
  chakra,
  Box,
  Container,
  Flex,
  Text,
  useMultiStyleConfig,
  Icon,
} from '@chakra-ui/react';
import { Navigate } from 'react-router-dom';
import { config } from 'config';

import { FramelessTitleBar } from 'app/components/TitleBar/FramelessTitleBar';
import { ReactComponent as BrandHorizontalLogo } from 'resources/images/full-logo.svg';
import { ReactComponent as CheckInSvg } from './CheckIn.svg';
import { ReactComponent as CreditsSvg } from './CreditsIcon.svg';

export const QrWindow = () => {
  const styles = useMultiStyleConfig('QrWindow', {});
  const [qr] = useState(localStorage.getItem('qr'));
  const isDesktop = config.isElectronBuild;

  const onWindowRefresh = () => {
    if (qr) {
      localStorage.setItem('qr', qr);
    }
  };

  useEffect(() => {
    localStorage.removeItem('qr');
  }, []);

  useEffect(() => {
    window.addEventListener('beforeunload', onWindowRefresh);
    return () => {
      window.removeEventListener('beforeunload', onWindowRefresh);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!qr) {
    return <Navigate to="/" />;
  }

  return (
    <>
      {isDesktop && (
        <FramelessTitleBar theme={{ bar: { borderBottom: 'none' } }} />
      )}
      <Container
        sx={styles.container}
        {...(isDesktop ? { marginTop: 12 } : {})}
      >
        <Flex sx={styles.wrapper}>
          <Icon as={BrandHorizontalLogo} role="img" sx={styles.logoImage} />
          <Box sx={styles.qrWrapper}>
            <chakra.img
              sx={styles.qrImage}
              src={qr}
              alt="QR code"
              data-testid="window-qr-image"
            />
          </Box>
          <Flex direction="column" pt={6}>
            <Text
              as="h6"
              fontSize="lg"
              lineHeight="24px"
              fontWeight={600}
              pb={4}
            >
              To Check In to Session
            </Text>
            <Flex direction="column" px="3px">
              <Flex alignItems="center" w="full" pb={4}>
                <Text sx={styles.listText}>1. Open Session on your phone</Text>
              </Flex>
              <Flex alignItems="center" w="full" pb={4}>
                <Text sx={styles.listText}>
                  2. Go to <b>Credits</b>
                </Text>
                <Icon as={CreditsSvg} sx={styles.listIcon} />
              </Flex>

              <Flex alignItems="center" w="full" pb={4}>
                <Text sx={styles.listText}>3. Tap Check In</Text>
                <Icon as={CheckInSvg} sx={styles.listIcon} color="iconAccent" />
              </Flex>
              <Flex alignItems="center" w="full">
                <Text sx={styles.listText}>4. Scan this QR code</Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Container>
    </>
  );
};
